var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view'),_c('SkuScannerDialog',{model:{value:(_vm.scannerDialogVisible),callback:function ($$v) {_vm.scannerDialogVisible=$$v},expression:"scannerDialogVisible"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }